import { MoneyAmount } from '../value-objects/MoneyAmount';

export interface YearResultInit {
  yearIndex: number;
  portfolioStart: number;
  withdrawal: number;
  income: number;
  extraExpense: number;
  portfolioEnd: number;
  success: boolean;
}

export class YearResult {
  readonly yearIndex: number;
  readonly portfolioStart: MoneyAmount;
  readonly withdrawal: MoneyAmount;
  readonly income: MoneyAmount;
  readonly extraExpense: MoneyAmount;
  readonly portfolioEnd: MoneyAmount;
  readonly success: boolean;

  constructor(init: YearResultInit) {
    this.yearIndex = init.yearIndex;
    this.portfolioStart = new MoneyAmount(init.portfolioStart);
    this.withdrawal = new MoneyAmount(init.withdrawal);
    this.income = new MoneyAmount(init.income);
    this.extraExpense = new MoneyAmount(init.extraExpense);
    this.portfolioEnd = new MoneyAmount(init.portfolioEnd);
    this.success = init.success;
  }

  equals(other: YearResult): boolean {
    return this.yearIndex === other.yearIndex;
  }
}